module.exports = __webpack_public_path__ + "img/album03_02.acc9f100.jpg";